const scxml = require('../../../../libraries/scxml/dist/scxml.js')

module.exports = scxml
module.exports.default = scxml



// WEBPACK FOOTER //
// ./src/vendor/scxml.js